import Box from '@mui/material/Box';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

interface DescribedMenuItemProps extends Omit<MenuItemProps, 'children'> {
  description?: string;
  label: string;
}

export default function DescribedMenuItem({
  description,
  label,
  ...menuItemProps
}: DescribedMenuItemProps) {
  return (
    <MenuItem {...menuItemProps}>
      <Box>
        <Typography variant="subtitle2">{label}</Typography>
        {description && (
          <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
            {description}
          </Typography>
        )}
      </Box>
    </MenuItem>
  );
}
